<template>
  <div
    class="rewards-result-box"
    :class="{'padding-top-b': !isOpen}"
    @click="openMyRewards('card')"
  >
    <p
      class="title"
      v-if="isOpen"
      @click.stop="openMyRewards"
    >
      <span class="content">{{$t('我的奖励')}}</span>
      <i class='icon-outline_entrance'></i>
    </p>
    <div class="profit-box">
      <div class="profit-item">
        <p class="profit-money">{{ rewardedAmount }}</p>
        <p class="profit-desc">{{$t('已获得奖励')}}</p>
      </div>
      <div class="profit-item">
        <p class="profit-money">{{ pendingAmount }}</p>
        <p class="profit-desc">{{$t('待入账奖励')}}</p>
      </div>
      <p class="line"></p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'RewardsMoney',
  props: {
    rewardedAmount: String,
    pendingAmount: String,
    isOpen: Boolean,
  },
  data() {
    return {
    }
  },
  components: {
    ...mapState('common', ['isH5']),
  },
  methods: {
    openMyRewards(type) {
      if (!this.isOpen) return
      if (type !== 'card' || this.isH5) {
        this.$emit('open-my-rewards')
      }      
    }
  }
}
</script>
<style lang="scss" scoped>
.rewards-result-box {
  padding-bottom: 12px;
  background: #FFFFFF;
  border-radius: 8px;
}
.padding-top-b {
  padding: 14px 0;
}
.rewards-result-box .title {
  display: inline-block;
  margin: 23px 16px 10px;
  line-height: 20px;
  font-family: 'Aspira Light';
  font-size: 16px;
  color: #000000;
  cursor: pointer;
}
.rewards-result-box .title .content {
  display: inline-block;
  vertical-align: middle;
}
.rewards-result-box .title i {
  display: inline-block;
  margin-left: 4px;
  font-size: 14px;
  vertical-align: middle;
}
.profit-box {
  position: relative;
  display: flex;
}
.profit-item {
  flex: 1;
  padding: 12px 16px;
  text-align: center;
  color: #000000;
}
.profit-money {
  line-height: 20px;
  font-family: 'Aspira Medium';
  font-size: 20px;
  font-weight: 500;
}
.profit-desc {
  margin-top: 8px;
  font-family: 'Aspira Light';
  font-size: 12px;
  font-weight: 200;
}
.line {
  position: absolute;
  top: 12px;
  right: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 40px;
  background: #E5E5E5;
}
@media screen and (max-width: 768px) {
  .rewards-result-box {
    padding-bottom: rem(32);
    border-radius: rem(12);
  }
  .padding-top-b {
    padding: rem(32) 0;
  }
  .rewards-result-box .title {
    display: inline-block;
    margin: rem(30) rem(24);
    line-height: rem(32);
    font-size: rem(28);
  }
  .rewards-result-box .title i {
    font-size: rem(32);
  }
  .profit-item {
    padding: rem(16);
  }
  .profit-money {
    line-height: rem(40);
    font-size: rem(40);
  }
  .profit-desc {
    margin-top: rem(16);
    font-size: rem(24);
  }
  .line {
    position: absolute;
    top: rem(16);
    height: rem(80);
  }
}
</style>